import { render, staticRenderFns } from "./CreateAnnouncement.vue?vue&type=template&id=102357b1&scoped=true&"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=js&"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./CreateAnnouncement.vue?vue&type=style&index=0&id=102357b1&lang=scss&scoped=true&"
import style1 from "./CreateAnnouncement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102357b1",
  null
  
)

export default component.exports